import type { LuggageAccommodate, Place, RegistLuggage, ServiceBasicFee, ServiceFee, Vehicle } from "../my-type";

export const getVehicleFeeWithAddress = (serviceFeeData: ServiceFee[], vehicle: Vehicle, place: Place, airportID: string): ServiceBasicFee | undefined => {
  var vehicleServiceFeeData = serviceFeeData;

  let serviceFeesByAirportID = vehicleServiceFeeData.find(element => element.airportID === airportID);
  if (serviceFeesByAirportID) {
    let serviceFee: ServiceBasicFee | undefined = undefined;

    serviceFeesByAirportID.basicPrice.forEach(element => {

      console.log("Checking city list:", element.city, " for place:", place.firstLevel, " and vehicleID:", vehicle.vehicleID);
      if (element.city.indexOf(place.firstLevel) !== -1 && element.vehicleID === vehicle.vehicleID) {
        serviceFee = element;
      }
    });

    return serviceFee;
  } else {
    //airport has not been defined in vehicle fee table
    return undefined;
  }

}

export const checkIsVehicleCanFit = (varVehicle: Vehicle, numberOfPassenger: number, userRegistLuggages: RegistLuggage[]): boolean => {

  //console.log("Checking Vehicle:{0}", varVehicle);

  //check number of total passengers
  if (varVehicle.peopleLimit < (numberOfPassenger)) {
    return false;
  }

  let userRegistLuggageReal = userRegistLuggages.filter((element) => element.quantity > 0);
  //console.log("User regist luggage:{0}", userRegistLuggageReal);
  if (userRegistLuggageReal.length === 0) {
    return true;
  }

  //find size and quantity of largest luggage
  let maxRegistLuggageSize = userRegistLuggageReal.reduce((acc, value) => {
    return (acc = acc > value.luggage.size ? acc : value.luggage.size)
  }, 0)
  //console.log("MaxRegistLuggageSize:{0}", maxRegistLuggageSize);

  let totalRegistLuggageQty = userRegistLuggageReal.reduce((acc, curr) => acc + curr.quantity, 0);
  //console.log("TotlaRegistLuggageQty:{0}", totalRegistLuggageQty);

  let maxRegistLuggageQty = userRegistLuggageReal.find((element) => element.luggage.size === maxRegistLuggageSize)?.quantity;
  //console.log("MaxRegistLuggageQty:{0}", maxRegistLuggageQty);

  //check if Vehicle can support , check if vehicle can support largest luggage size
  let maxLuggageAccForUser: LuggageAccommodate | undefined = varVehicle.luggageSupporting.find((element) => element.luggage.size >= maxRegistLuggageSize);
  //console.log("MaxLuggageAccommdateForUser:", maxLuggageAccForUser);
  if (maxLuggageAccForUser && maxRegistLuggageQty) {

    //keeeeeeeeep following code

    // if (maxRegistLuggageQty > maxLuggageAccForUser.quantity) {
    //   if (userVehicle && userVehicle.id === varVehicle.id) {
    //     setUserVehicle(undefined);
    //   }
    //   return false;
    // } else {
    //   //check vehicle totoal luggage limit
    //   if (varVehicle.totalLuggageLimit < totalRegistLuggageQty) {
    //     if (userVehicle && userVehicle.id === varVehicle.id) {
    //       setUserVehicle(undefined);
    //     }
    //     return false;
    //   } else {
    //     return true;
    //   }
    // }

    //check if vehicle can support all largest luggages
    if (maxLuggageAccForUser.quantity < maxRegistLuggageQty) {
      return false;
    }

    // check vehicle can support all luggages
    if (totalRegistLuggageQty > varVehicle.totalLuggageLimit) {
      // if (userVehicle && userVehicle.id === varVehicle.id) {
      //   setUserVehicle(undefined);
      // }
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }

}
